import { Box } from "@chakra-ui/react";
import React from "react";

const PaginationButton = ({ children, isSelected }) => {
  return (
    <Box
      background={isSelected && "#3498DB"}
      color={isSelected && "white"}
      width={"2rem"}
      textAlign={"center"}
      cursor={isSelected ? "default" : "pointer"}
    >
      {children}
    </Box>
  );
};

export default PaginationButton;
